import { useMutation } from '@tanstack/react-query';
import { type RefundInput, gqlClient, graphql, queryClient } from '@tyro/api';
import { toast } from '@tyro/core';
import { useTranslation } from '@tyro/i18n';
import { feeKeys } from './keys';

const refund = graphql(/* GraphQL */ `
  mutation fees_refund($input: RefundInput!) {
    fees_refund(input: $input) {
      success
    }
  }
`);

export function useRefund() {
  const { t } = useTranslation(['common', 'fees']);

  return useMutation({
    mutationFn: (input: RefundInput) => gqlClient.request(refund, { input }),
    onSuccess: async () => {
      await queryClient.invalidateQueries({ queryKey: feeKeys.all });
      toast.success(t('fees:refundSuccess'));
    },
    onError: () => {
      toast.error(t('common:snackbarMessages.errorFailed'));
    },
  });
}
